@if(strichService.isInitialized()) {
    <!-- Container -->
    <div class="position-fixed top-0 start-0 w-100 h-100 bg-black d-flex flex-column" style="z-index: 9999;">
        <!-- Audio Btn-->
        <div class="position-fixed top-0 end-0 m-2 text-white" style="z-index: 9999;">
            <fa-icon [icon]="scannerService.useAudio() ? fa.faVolume : fa.faVolumeSlash" class="fa-xl" (click)="toggleUseAudio()"></fa-icon>
        </div>
        <!-- Scan Count -->
        @if(scanCount() > 0) {
            <div 
                class="position-absolute top-0 w-100 d-flex justify-content-center" 
                style="z-index: 1000; opacity: 0.7; pointer-events: none;" 
                [class.scan-highlight]="recentScan()"
            >
                <div class="bg-primary text-white rounded p-2 mt-2 pointer-events-auto">
                    Scans: {{ scanCount() }}
                </div>
            </div>
        }
        <!-- Scanner -->
        <pcg-strich-scanner #scanner class="flex-grow-1"></pcg-strich-scanner>
        <button class="btn btn-md btn-primary w-100 mb-2" (click)="finishScanning()">
            Finished Scanning
        </button>
    </div>
} @else {
    <!-- Placeholder -->
    <div class="flex-grow-1 d-flex justify-content-center align-items-center text-white">
        Initializing scanner...
    </div>
}

<!-- For testing: -->
<!-- <div>
    <button class="btn btn-primary" (click)="testApiCall()">Hit API</button>
</div> -->